const apiAddress = 'http://localhost:28082/'

const apiOption = {
	method:'GET',
	mode: 'cors',
}

const apiCall = async (command, id, callback=null,failure=null) => {
	try {
		const response = await fetch(apiAddress + command + '/'+id, apiOption)
		const json = await response.json()
		if (json.result==='OK'||json.result==='NEED' || json.result==='ER') {
			if(callback!==null) callback(json)
		} else if (json.result==='WAIT') {
			console.log('Wait Retry')
			setTimeout(()=>apiCall(command, id, callback,failure),1000)
		} else {
			alert(json.message)
		}
	} catch(e) {
		console.log(e)
		alert('ローカルコントローラーが起動していません。\nCommand:'+command + '/'+id)
		if(failure!==null) failure()
	}
}
export default apiCall
